/* eslint-disable
    consistent-return,
    guard-for-in,
    no-func-assign,
    no-restricted-syntax
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Adapter to UniCloud: i18n-cloud.appspot.com
import CharPickerData from 'char-picker-data';
import $ from 'jquery';
import React from 'react';
import PropTypes from 'prop-types';

import * as logging from 'util/Logging';
import * as net from 'util/Net';
import {noop} from '@benchling/js-utils';

const UNICLOUD_PROPERTIES_ENDPOINT = '/1/api/uni-cloud/cproperties';
const UNICLOUD_SEARCH_ENDPOINT = '/1/api/uni-cloud/csearch';

function notifyUnicloudError(resp, endpoint, params) {
  notifyUnicloudError = noop; // Disable after initial call.
  logging.error(`UniCloud: request to endpoint ${endpoint}?${$.param(params)} failed with error code \
${resp.status}`);
}

class UniCloud extends React.PureComponent {
  static propTypes = {
    char: PropTypes.string.isRequired,
    children: PropTypes.func.isRequired,
  };

  static _queryEndpoint(endpoint, params) {
    return net.getJSONPromise(endpoint, params).catch((resp) => {
      // Warn us and forward the error.
      notifyUnicloudError(resp, endpoint, params);
      throw resp;
    });
  }

  static searchChars(query) {
    return UniCloud._queryEndpoint(UNICLOUD_SEARCH_ENDPOINT, {p: 'name', q: query}).then((resp) => {
      const results = [];
      for (const key in resp) {
        results.push(CharPickerData.helpers.fromCharCode(parseInt(key, 16)));
      }
      return results;
    });
  }

  state = {name: undefined};

  fetchName = (char) => {
    this.setState({name: undefined});
    const charCode = CharPickerData.helpers.toCharCode(char).toString(16);
    UniCloud._queryEndpoint(UNICLOUD_PROPERTIES_ENDPOINT, {p: 'name', c: charCode})
      .then((resp) => {
        // eslint-disable-next-line no-unreachable-loop
        for (const key in resp) {
          // Only expecting one, return the first one.
          const data = resp[key];
          return data.name;
        }
      })
      .catch(() => '\u00A0')
      .then((name) => {
        if (this._isMounted && this.props.char === char) {
          this.setState({name});
        }
      });
  };

  componentDidMount() {
    this.fetchName(this.props.char);
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.char !== this.props.char) {
      this.fetchName(nextProps.char);
    }
  }

  render() {
    const codePoint = CharPickerData.helpers.toHexString(this.props.char);
    return this.props.children({name: this.state.name, codePoint});
  }
}

export default UniCloud;
